<div class="col-xs-12">
  <div class="btn-group">
    <div class="btn btn-default btn-sm btn-action" ng-click="goToIndex()">Voltar</div>
    <div class="btn btn-primary btn-sm btn-action" ng-click="edit()" ng-if="permissions.usuario.canManage">
      Editar <i class="glyphicon glyphicon-pencil"></i>
    </div>
  </div>
</div>